var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,{tag:"component",attrs:{"detailLayout":_vm.detailLayout,"utilityData":_vm.utilityData,"utilKey":_vm.utilKey,"userKey":_vm.userKey,"utilTopCategory":_vm.utilityTopCategoryList,"utilBottomCategory":_vm.utilityBottomCategoryList}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }